/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UsageCycleNumber {
    one = 1,
    four = 4,
    six = 6,
    eight = 8,
    thirteen = 13,
    twentySix = 26,
    thirty = 30,
    thirtyOne = 31,
    fiftyTwo = 52,
}
